import React, { useMemo, useState } from 'react';
import TrafficGraph from './analytics/TrafficGraph';
import Graph from './analytics/Graph';

const Analytics = ({site, setReady}) => {
  const [whichTraffic, setWhichTraffic] = useState('bar');

  const data = useMemo(() => {
    const trafficData = {
      title: 'Traffic',
      values: {
        human: site.data.map(entry => {
          return Object.values(entry).map(x => x[0]).reduce((a, b) => a + b, 0);
        }),

        bot: site.data.map(entry => {
          return Object.values(entry).map(x => x[1]).reduce((a, b) => a + b, 0);
        }),
        old: site.oldCounts,
      },
      lastDay: site.lastDay,
    };

    const getPlatformTotal = (entry, index) => {
      let total = 0;
      for (let key of Object.keys(entry)) {
        let platformIndex = parseInt(key.split('-')[1]);
        if (platformIndex === index) {
          total += entry[key][1];
        }
      }
      return total;
    };

    const getCampaignTotal = (entry, index) => {
      let total = 0;
      for (let key of Object.keys(entry)) {
        let campaignIndex = parseInt(key.split('-')[0]);
        if (campaignIndex === index) {
          total += entry[key][1];
        }
      }
      return total;
    };

    const platformValues = site.platforms.map((platform, index) => {
      return {name: platform,
              data: site.data.map(entry => {
                return getPlatformTotal(entry, index);
              })}
    })
      .sort((a, b) => {
        return b.data.reduce((x, y) => x + y, 0) - a.data.reduce((x, y) => x + y, 0);
      });

    const platformData = {
      title: 'Platform',
      values: platformValues,
      lastDay: site.lastDay,
    };

    const campaignValues = site.campaigns.map((campaign, index) => {
      return {name: campaign,
              data: site.data.map(entry => {
                return getCampaignTotal(entry, index);
              })}
    })
      .sort((a, b) => {
        return b.data.reduce((x, y) => x + y, 0) - a.data.reduce((x, y) => x + y, 0);
      });

    const campaignData = {
      title: 'Campaign',
      values: campaignValues,
      lastDay: site.lastDay,
    };

    return [trafficData, platformData, campaignData];
  }, [site]);

  return (
    <>
      <h4 className="section-header">Analytics</h4>
      <div className="analytics section-box">
        <div className="analytics-traffic">
          <TrafficGraph specs={data[0]} setReady={setReady} which={whichTraffic} setWhich={setWhichTraffic}/>
        </div>

        <div className="analytics-compare">
          <div className="chart-half">
            <Graph specs={data[1]} setReady={setReady}/>
          </div>

          <div className="chart-half">
            <Graph specs={data[2]} setReady={setReady}/>
          </div>
        </div>
      </div>
    </>
  );
}

export default Analytics;
